export const SpaceOpsFlags = {
  BillingPaymentsInvoicesSubcriptions: 'space-ops.tab-subscription-invoices',
  BillingPaymentsUciPaymentRefactor: 'space-ops.uci-payment-refactor',
  BillingPaymentsDownloadInvoice: 'space-ops.download-invoice',
  SpaceOpsCancelSubscriptionAndUci: 'space-ops.cancel-sub-and-uci',
  VisitorManagementBufferTime: 'space-ops.visitor-management-buffer-time',
  VisitorManagementDateRangeMax: 'space-ops.date-range-max',
  VisitorManagementICSEmail: 'space-ops.visitor-management-ics',
  WorkOrdersPDF: 'space-ops.work-orders-pdf',
  EuPaymentCompliance: 'space-ops.eu-payment-compliance',
  PaymentSubmitOnBehalfOfExclusivity:
    'space-ops.payment-submit-on-behalf-exclusivity',
  FlatfileUpgradeToPlatform: 'space-ops.flatfile-upgrade-to-platform',
  WorkOrdersServiceRequestInvoicingOptions:
    'space-ops.work-orders-service-requests-invoicing',
  WorkOrdersEmailUIV2: 'space-ops.work-orders-email-UI',
  VisitorManagementFloorSync: 'space-ops.visitor-management-floor-sync',
  EnableServiceRequestTaskTime: 'space-ops.work-orders-service-requests-hours',
  WorkOrderSpecificTeamWorkflowTarget:
    'space-ops.work-orders-specific-team-workflow-targeting',
  WorkOrderCommentNotificationEmail:
    'space-ops.work-order-comment-notification.email',
  EnableBillingProductServicesCRUD: 'space-ops.billing-product-services-CRUD',
  GenerateServiceRequestFromPreventiveMaintenanceTask: 'space-ops.work-orders-generate-service-request-from-preventive-maintenance-task',
  PMTaskAutoExpiration: 'space-ops.work-orders-pm-task-auto-expiration',
  ServiceRequestChargeOverride: 'space-ops.service-request-charge-override',
  ProductsAndServices: 'squad-billing-and-payments.products-and-services',
  PaymentFeatureV2: 'squad-billing-and-payments.payment-feature-v2',
  TransactionHistoryV2: 'squad-billing-and-payments.transaction-history-v2',
  ChargesInvoice: 'squad-billing-and-payments.charges-invoice-v1',
  PaymentSettings: 'squad-billing-and-payments.payment-settings',
  YardiChargeCode: 'squad-billing-and-payments.yardi-charge-code-sync',
  AutopaymentFailureEmail:
    'squad-billing-and-payments.autopayment-failure-email',
  Credits: 'squad-billing-and-payments.credits',
  CreditBundlesInCharges: 'squad-billing-and-payments.credit-bundles-in-charge',
  ProductsInContent: 'squad-billing-and-payments.products-in-content',
  SubscriptionsInContent: 'squad-billing-and-payments.subscriptions-in-content',
  Exceptions: 'squad-billing-and-payments.exceptions',
  InvoiceDisabling: 'squad-billing-and-payments.invoice-disabling',
  RemovePaymentAccounts: 'squad-billing-and-payments.remove-payment-accounts',
  ProductsWithCredits: 'squad-billing-and-payments.products-with-credit-price',
  ChargeBillingReports: 'squad-billing-and-payments.billing-reports',
  ApplePay: 'squad-billing-and-payments.apple-pay',
  PriceOnCard: 'squad-billing-and-payments.price-on-card',
  AutopaymentInContent: 'squad-billing-and-payments.autopayment-in-content',
  WorkOrderMobileEquipment: 'work-orders.admin-mobile-equipment',
  DataImporter: 'work-orders.data-importer',
  ImporterConverter: 'work-orders.importer-converter',
  WorkOrdersSuperConverter: 'work-orders.super-converter',
  InteractiveStepsCreate: 'work-orders.interactive-steps-create',
  InteractiveStepsDetails: 'work-orders.interactive-steps-details',
  InteractiveStepsExecute: 'work-orders.interactive-steps-execute',
  WorkOrderTenantSurveys: 'work-orders.tenant-survey',
  WorkOrdersAuditLogs: 'work-order.audit-logs',
  WorkOrderComments: 'work-order.comments',
  WorkOrderCommentsMobile: 'work-order.comments-mobile',
  WorkOrdersOnlyDisplayKnownFilters:
    'work-order.only-display-allowed-statuses-on-filter',
  WorkOrdersDisplayEscalationFilter: 'work-order.display-escalation-filter',
  WorkOrdersConfigurableNotifications: 'work-order-configurable-notifications',
  useNewAlertModalDesign: 'squad-work-order.new-alert-modal',
  WorkOrderOotbConfigurationUpdate:
    'squad-work-order.ootb-configuration-update',
  RiseMigrationAutoSetup:
    'platform-application-services.rise-migration-option-for-auto-setup',
  Surveys: 'platform-application-services.surveys',
  SendUserIdAsLookerAttribute:
    'platform-application-services.send_user_id_as_looker_attribute',
  WithholdChannelListFromLooker:
    'platform-application-services.withhold_channel_list_from_looker',
  SourceLookerFromVTS: 'platform-application-services.source_looker_from_vts',
  SourceLookerFromVTSGroup2:
    'platform-application-services.source_looker_from_vts_group_2',
  ChangeParent: 'platform-application-services.change-parent',
  SyncJoinRules: 'platform-application-services.sync-join-rules',
  LookerTimezoneParams: 'platform-application-services.looker_timezone_params',
  LaneLookerTimezoneParams:
    'platform-application-services.lane_looker_timezone_params',
  CESAutoSetup: 'platform-application-services.ces-option-for-auto-setup',
  RiseMigrationExportTenants:
    'platform-application-services.rise-migration-migrate-tenants',
  RiseMigrationAddRandomSuffix:
    'platform-application-services.rise-migration-add-random-suffix',
  EventAnalyticsLookerReport:
    'platform-application-services.event-analytics-looker-report',
  TeamsBulkAddUsers: 'platform-application-services.teams-bulk-add-users',
  TenantManagement: 'workorders.activate.tenant.managment',
  TenantManagementTenantImport:
    'workorders.activate.tenant.management-import.tenants',
  TenantManagementHideButtons:
    'workorders.activate.tenant.management-hide.tenant.buttons',
  TenantManagementAddTenantsUI:
    'workorders.activate.tenant.management.add-tenants-ui',
  EnableCesLinksForServiceRequests:
    'workorders.service-requests.enable.ces.links',
  UseParamWhiteLabelIdForPushNotification:
    'workorders.push-notifications.use-param-white-label-id',
  NotificationsBatchRestore: 'workorders.notifications.batch-restore',
  NotificationsCrudStrategyV2: 'workorders.notifications.crud-strategy.v2',
  WorkordersMaintainSettingsConfigurations:
    'workorders.maintain-settings-configurations',
  ScheduleServiceRequestDueDate: 'space-ops.schedule-service-request-due-date',
  ServiceRequestReminderWorkflowRule:
    'space-ops.service-request-reminder-workflow-rule',
  SpaceOpsCurrencyExpansion: 'space-ops.currency-expansion',
  BpMarkupChargeCode: 'space-ops.bp-markup-charge-code',
  BulkPaidInvoices: 'space-ops-2.bulk-paid-invoices',
  SpaceOpsModuleRoles: 'space-ops.module-roles',
  BuildingManagementTenantRoles: 'space-ops-2.building-management-tenant-roles',
  SpaceOpsPmBulkActions: 'space-ops-pm-bulk-actions',
  SpaceOpsSrBulkActions: 'space-ops-sr-bulk-actions',
  Inspections: 'activate-inspections',
  // Rogue flags
  SpaceInvadersVisitorsPrinterIntegration:
    'space-invaders-visitors-printer-integration',
  SpaceInvadersRecurrenceEventSourcing:
    'space-invaders.recurrence-event-sourcing',
  SpaceInvadersSecurityStaffVisitCreationView:
    'space-invaders.security-staff-visit-creation-view',
  SpaceInvadersVisitorsDymoIntegration:
    'space-invaders.visitors-dymo-integration',
  SpaceInvadersVisitorsPrinterIntegrationDot:
    'space-invaders.visitors-printer-integration',
  SpaceOpsProductCatalogTableFilters: 'space-ops-product-catalog-table-filters',
  SpaceOpsCreExternalReferenceManualEntry:
    'space-ops.cre-external-reference.manual-entry',
  SpaceOpsIntegratedSetUpcomingFix: 'space-ops.integrated-set-upcoming-fix',
  SpaceOpsLastConnectedPrinterDebug: 'space-ops.last-connected-printer-debug',
  SpaceOpsPrinterSelectionEnabledForPrintPass:
    'space-ops.printer-selection-enabled-for-print-pass',
  SpaceOpsSkipValidatedPassRotation: 'space-ops.skip-validated-pass-rotation',
  SpaceOpsStreamSrCommentReminderEventType:
    'space-ops.stream.sr-comment-reminder-event-type',
  SpaceOpsTenancyModelStrategyV2: 'space-ops.tenancy-model-strategy.v2',
  SpaceOpsVisitorManagementPrintCompanyOnPass:
    'space-ops.visitor-management-print-company-on-pass',
  SquadBillingAndPaymentsAmountTenThousands:
    'squad-billing-and-payments.amount-ten-thousands',
  SquadBillingAndPaymentsAutopaymentWhitelabelSupport:
    'squad-billing-and-payments.autopayment-whitelabel-support',
  SquadBillingAndPaymentsBillingSchedule:
    'squad-billing-and-payments.billing-schedule',
  SquadBillingAndPaymentsChargeWithProducts:
    'squad-billing-and-payments.charge-with-products',
  SquadBillingAndPaymentsInvoiceAutopayment:
    'squad-billing-and-payments.invoice-autopayment',
  SquadBillingAndPaymentsInvoiceVoidStatus:
    'squad-billing-and-payments.invoice-void-status',
  SquadBillingAndPaymentsListInvoicesForAccountAndCompany:
    'squad-billing-and-payments.list-invoices-for-account-and-company',
  SquadBillingAndPaymentsListInvoicesForCompany:
    'squad-billing-and-payments.list-invoices-for-company',
  SquadBillingAndPaymentsMemberships: 'squad-billing-and-payments.memberships',
  SquadBillingAndPaymentsPayForInvoice: 'squad-billing-and-payments.pay-for-invoice',
  SquadBillingAndPaymentsPaymentSettingsAmountFix: 'squad-billing-and-payments.payment-settings-amount-fix',
  SquadBillingAndPaymentsRecurringCharges: 'squad-billing-and-payments.recurring_charges',
  SquadBillingAndPaymentsVoidCharge: 'squad-billing-and-payments.void-charge',
  WorkOrderShowViolationTime: 'work-order.show-violation-time',
  WorkOrderWorkplaceEnablement: 'work-order.workplace-enablement',
  WorkOrdersAdhocTaskCreation: 'work-orders.adhoc-task-creation',
  WorkOrdersInteractiveStepsEdit: 'work-orders.interactive-steps-edit',
  WorkOrdersServiceRequestInvoicing: 'work-orders.service-request-invoicing',
  EnableConditionalWorkOrder: 'enable-conditional-work-order',
  PlatformApplicationServicesLookerReports:
    'platform-application-services.looker-reports',
  PlatformApplicationServicesRiseMigrationExportPerks:
    'platform-application-services.rise-migration-export-perks',
  // Rogue flags end
} as const;
